import { ProductCarousel, ProductCarouselProps } from './ProductCarousel';

/**
 * A thin wrapper on ProductCarousel that will force the component to render its
 * skeleton (which was already defined within the ProductCarousel component)
 */
export const ProductCarouselSkeleton = (props: ProductCarouselProps) => {
  return <ProductCarousel {...props} skeletonOnly />;
};
